import selector, {identitySelector} from 'utils/selector'
import {RouteComponentProps} from 'react-router-dom'
import {Optional, Problem, ProblemSolution} from 'data/types'
import config from 'config'

export default class RouterService {
  private router?: RouteComponentProps

  public initialize(router: RouteComponentProps) {
    if (this.router != null) {
      return
    }
    this.router = router
  }

  public push = (path: string) => {
    if (config.isChromeExtension) {
      return // no-op
    }
    this.router?.history.push(path)
  }

  public getSelectedProblemId = (pathname: string) => {
    return pathname.match(/projects\/[0-9]+\/problems\/([0-9]+)\/?/)?.[1]
  }

  public selectProject = (projectId: Optional<string | number>) => {
    if (projectId == null) {
      this.push(`/projects`)
    } else {
      this.push(`/projects/${projectId}`)
    }
  }

  public selectSolutions = (problem: Problem) => {
    this.push(`/projects/${problem.projectId}/problems/${problem.id}/solutions`)
  }

  public selectSolution = (problem: Problem, solution: ProblemSolution) => {
    this.push(`/projects/${problem.projectId}/problems/${problem.id}/solutions/${solution.id}`)
  }

  public selectProblem = (problem: Problem, shouldOpenSolutionsIfAvailable = true) => {
    if (problem.solutionsCount > 0 && shouldOpenSolutionsIfAvailable) {
      this.push(`/projects/${problem.projectId}/problems/${problem.id}/solutions`)
    } else {
      this.push(`/projects/${problem.projectId}/problems/${problem.id}`)
    }
  }
}

export const routerServiceSelector = selector(identitySelector<null>(), () => new RouterService())
